// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","header":"_3cGsN","publicationDate":"_37UNG","title":"_29iO9"};